// extracted by mini-css-extract-plugin
export default {"box":"index_box_HGdrQ","title":"index_title_b-xIz"};